import React, { useEffect, useState } from 'react';
import { Container, Spinner, Alert, Button } from 'react-bootstrap';
import axiosInstance from '../api/axiosInstance';

const SitemapPage = () => {
  const [sitemap, setSitemap] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSitemap = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get('/seo/sitemap.xml');
        if (!response.ok) throw new Error('Erro ao buscar o sitemap');
        const text = await response.text();
        setSitemap(text);
        setError('');
      } catch (err) {
        setError('Erro ao carregar o sitemap.');
      } finally {
        setLoading(false);
      }
    };
    fetchSitemap();
  }, []);

  const handleDownload = () => {
    const blob = new Blob([sitemap], { type: 'application/xml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'sitemap.xml';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Container className="my-5">
      <h1>Sitemap XML</h1>
      {loading ? (
        <Spinner animation="border" />
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : (
        <>
          <Button onClick={handleDownload} className="mb-3">Download sitemap.xml</Button>
          <pre style={{ background: '#f8f9fa', padding: 16, borderRadius: 8, overflowX: 'auto' }}>{sitemap}</pre>
        </>
      )}
    </Container>
  );
};

export default SitemapPage; 